import { baseEnvironment } from './base.environment';

export const environment = {
  ...baseEnvironment,
  title: 'CR LINC - Dev',
  oktaAuthIssuerURL: 'https://tcenergyhub.oktapreview.com/oauth2/default',
  oktaClientId: '0oa5w6lrseIYn4WUE1d7',
  graphQLUrl: 'https://api-flask.crlinc-dev.tcenergy.com/graphql',
  fieldVisionUrl: 'https://fv.crlinc-dev.tcenergy.com/',
  publicFunctionApiKey: 'da2-7v4pbcmc3bcpjat7vb4zb4d7xm',
};
